import { createContext, useState, useEffect } from "react";
import { searchNameByInitial } from "../services/userServices";
import { searchNameTeamByInitial } from "../services/teamService";

export const SearchContext = createContext()

export function SearchProvaider({children}){

    const loadOptionsName = async (inputValue) => {
        if (!inputValue || inputValue.trim().length < 2) return []
            
        const data = await searchNameByInitial(inputValue.trim())
            
        if (!Array.isArray(data)) return []
            
        return data.map((user) => ({
            value: user.id,
            label: user.name_user
        }))
    }

    const loadOptionsNameTeam = async (inputValue) => {
        if (!inputValue || inputValue.trim().length < 2) return []
            
        const data = await searchNameTeamByInitial(inputValue.trim())
            
        if (!Array.isArray(data)) return []
            
        return data.map((team) => ({
            value: team.id,
            label: team.name
        }))
    }

    return(
        <SearchContext.Provider value={{loadOptionsName, loadOptionsNameTeam}}>
            {children}
        </SearchContext.Provider>
    )
}